import { cn } from "@newxsystems/shared";
import type { ITootHeadingProps, TootHeadingAlignment, TootHeadingSize } from "./TootHeading.props";
import { RichTextHtml } from "../../../../cms/components/RichTextHtml";

const alignmentClasses: Record<TootHeadingAlignment, string> = {
  left: "items-start text-left",
  center: "mx-auto items-center text-center",
  right: "ml-auto items-end text-right",
};

const sizeClasses: Record<TootHeadingSize, string> = {
  hero: "toot-heading-hero",
  section: "toot-heading-section",
  compact: "toot-heading-compact",
};

export const TootHeading = ({
  actions,
  alignment = "left",
  as: HeadingTag = "h2",
  className,
  eyebrow,
  heading,
  headingId,
  inverse = false,
  microLabel,
  size = "section",
  subheading,
}: ITootHeadingProps) => {
  return (
    <div
      className={cn("flex flex-col gap-4", alignmentClasses[alignment], className)}
      data-toot-heading-stack=""
    >
      {microLabel ? <p className="toot-terminal-label">{microLabel}</p> : null}
      {eyebrow ? <p className="toot-eyebrow">{eyebrow}</p> : null}
      {heading ? (
        <HeadingTag
          className={cn(
            HeadingTag === "h2" ? "toot-heading-section" : sizeClasses[size],
            inverse && "text-[var(--color-primary-foreground)]",
          )}
          id={headingId}
        >
          {heading}
        </HeadingTag>
      ) : null}
      {subheading ? (
        <RichTextHtml
          className={cn(
            "toot-subheading",
            inverse && "text-[color-mix(in_oklab,var(--color-primary-foreground)_86%,transparent)]",
          )}
          html={subheading}
        />
      ) : null}
      {actions ? <div className="pt-2">{actions}</div> : null}
    </div>
  );
};

TootHeading.displayName = "Layout::TootHeading";
